import styles from "./style.module.scss";
import classNames from "classnames";
import { useEffect } from "react";
import VLButton from "../../../uikit/Buttons/VLButton";

interface SubmitButtonProps {
  isDisabled: boolean;
  onSubmit: () => void;
}

export default function SubmitQueryButton({
  isDisabled,
  onSubmit,
}: SubmitButtonProps) {
  const submitButtonClassnames = classNames(styles.submitButton, {
    [styles.disabled]: isDisabled,
  });

  useEffect(() => {
    if (isDisabled) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        onSubmit();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isDisabled, onSubmit]);

  return (
    <VLButton
      type="primary"
      size="middle"
      data-testid="query-modal-submit-button"
      className={submitButtonClassnames}
      onClick={onSubmit}
    >
      Apply
    </VLButton>
  );
}
